(() => {
  const translatedCopy = JSON.parse(document.querySelector('#ev-visual-assets')?.textContent || '{}').copy || {};
  const t = (key, fallback) => (translatedCopy[key] || fallback).replaceAll('&amp;', '&');
  const root = document.documentElement;
  if (!root.hasAttribute('data-evolve-site')) return;
  const main = document.querySelector('main');
  if (!main) return;
  const path = location.pathname.replace(/\/$/, '') || '/';
  const assets = JSON.parse(document.querySelector('#ev-visual-assets')?.textContent || '{}');
  const categories = [[t('all_jewelry','All jewelry'),'all'],[t('rings','Rings'),'rings'],[t('necklaces','Necklaces'),'necklaces'],[t('earrings','Earrings'),'earrings'],[t('bracelets','Bracelets'),'bracelets']];
  const help = [[t('shipping','Shipping'),'shipping'],[t('returns','Returns & exchanges'),'returns'],[t('size_guide','Size guide'),'size-guide'],[t('faq','FAQ'),'faq'],[t('contact','Contact'),'contact']];
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  const photo = (key, alt, className) => {
    const image = element('img',className);
    image.src = assets[key] || assets.gold;
    image.alt = alt;
    image.width = 1448;
    image.height = 1086;
    image.loading = 'lazy';
    return image;
  };
  const navigation = (items, prefix, label, className) => {
    const nav = element('nav',className);
    nav.setAttribute('aria-label',label);
    items.forEach(([title,handle]) => {
      const link = element('a','',title);
      link.href = `${prefix}/${handle}`;
      if (path === `${prefix}/${handle}`) link.setAttribute('aria-current','page');
      nav.append(link);
    });
    return nav;
  };
  const imageUrl = (source,width=750) => {
    const url = new URL(source,location.href);
    if (url.hostname !== location.hostname) url.protocol = 'https:';
    url.searchParams.set('width',String(width));
    return url.href;
  };
  const isModel = text => /\bmodel\s+(shot|wearing)\b|\bon[- ]model\b|\bworn by\b/i.test(text || '');
  const metalPrefix = /^(\d+K\s*\/\s*\d+K\s+(?:Yellow|White|Rose) Gold|\d+K Two-tone Yellow & Rose Gold|\d+K\s+(?:Yellow|White|Rose) Gold|\d+K (?:Yellow & Rhodium|Tri-Color|Two-tone)|Rhodium-Plated Sterling Silver|Sterling Silver|Platinum)\s+(.+)$/i;
  const products = new Map();
  const jobs = [];
  let running = 0;
  const drain = () => {
    while (running < 4 && jobs.length) {
      running++;
      const job=jobs.shift();
      job().finally(() => { running--; drain(); });
    }
  };
  const modelFor = handle => {
    if (!products.has(handle)) products.set(handle,new Promise(resolve => {
      jobs.push(async () => {
        try {
          const response = await fetch(`/products/${handle}.js`);
          if (!response.ok) return resolve(null);
          const product = await response.json();
          if (!window.EvolveProductPresentation?.hasNeutralOptions(product.options)) return resolve(null);
          resolve(product.media?.find(media => media.media_type === 'image' && isModel(media.alt)) || null);
        } catch { resolve(null); }
      });
      drain();
    }));
    return products.get(handle);
  };
  const preparePhoto = async link => {
    const primary = link.querySelector('.image-first-hover');
    if (!primary?.getAttribute('src') || link.querySelector('.ev-catalog-media') || !matchMedia('(any-hover: hover) and (any-pointer: fine)').matches) return;
    const layer = element('span','ev-catalog-media');
    layer.setAttribute('aria-hidden','true');
    const base = element('img','ev-catalog-photo');
    base.src = primary.currentSrc || primary.src;
    base.decoding = 'async';
    base.width = primary.width;
    base.height = primary.height;
    base.alt = '';
    layer.append(base);
    link.append(layer);
    try { await base.decode(); } catch { layer.remove(); return; }
    link.classList.add('ev-catalog-photo-ready');
    const handle = new URL(link.href).pathname.match(/\/products\/([^/]+)/)?.[1];
    if (!handle) return;
    const existing = link.querySelector('.image-second-hover');
    const model = existing && isModel(existing.alt) ? {src:existing.getAttribute('src'),alt:existing.alt} : await modelFor(handle);
    if (!model?.src) return;
    const alternate = element('img','ev-catalog-photo ev-catalog-alternate');
    alternate.src = imageUrl(model.src, Math.min(1000, Math.ceil(link.clientWidth * Math.min(devicePixelRatio, 2))));
    alternate.decoding = 'async';
    alternate.alt = '';
    alternate.dataset.photoDescription = model.alt;
    layer.append(alternate);
    try { await alternate.decode(); } catch { alternate.remove(); return; }
    if (existing) {
      existing.src=alternate.src;
      existing.removeAttribute('srcset');
      existing.alt=model.alt;
    }
    requestAnimationFrame(() => requestAnimationFrame(() => link.classList.add('ev-catalog-model-ready')));
  };
  const imageObserver = new IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    imageObserver.unobserve(entry.target);
    preparePhoto(entry.target);
  }),{rootMargin:'250px'});
  const preparedCards = new WeakSet();
  const prepareCardTitles = () => {
    const display = window.EvolveProductPresentation;
    if (!display) return;
    main.querySelectorAll('.card-product').forEach(card => {
      const title = card.querySelector('.card-info .x-card-title');
      if (!title) return;
      const sizes = card.querySelector('.card-meta-teaser')?.textContent.match(/(\d+)\s+sizes\b/i);
      const multipleSizes = Number(sizes?.[1]) > 1;
      const text = display.cleanTitle(title.textContent, multipleSizes);
      const fullTitle = display.cleanTitle(title.title || title.textContent, multipleSizes);
      if (title.textContent.trim() !== text) title.textContent = text;
      if (title.title && title.title !== fullTitle) title.title = fullTitle;
      card.querySelectorAll('.ev-card-details,.ev-catalog-details,.ev-pdp-card-details').forEach(link => {
        const label = `View details for ${fullTitle}`;
        if (link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
      });
    });
  };
  const prepareCards = () => {
    main.querySelectorAll('#items-grid .card-product,.ev-collection-edit .card-product,.main-cart-upsell .card-product').forEach(card => {
      if (preparedCards.has(card)) return;
      const title = card.querySelector('.card-info .x-card-title');
      const price = card.querySelector('.card-info .x-card-price');
      if (!title || !price) return;
      preparedCards.add(card);
      card.classList.add('ev-catalog-card');
      const fullTitle = title.title || title.textContent.trim();
      const match = fullTitle.match(metalPrefix);
      let metal = card.querySelector('.card-meta-metal');
      if (match) {
        if (!metal) { metal=element('div','card-meta-metal'); title.closest('.card__heading').before(metal); }
        metal.textContent=match[1].replace('Two-tone Yellow & Rose Gold','Yellow & Rose Gold');
        title.textContent=match[2].replace(/^Gold\s+/i,'');
      }
      if (!metal) {
        metal=element('div','card-meta-metal');
        metal.setAttribute('aria-hidden','true');
        title.closest('.card__heading').before(metal);
      }
      const teaser = card.querySelector('.card-meta-teaser');
      if (teaser && /\d+ sizes/i.test(teaser.textContent)) title.textContent=title.textContent.replace(/\s+Size\s+\d+(?:\.\d+)?\s*$/i,'');
      const ratings=card.querySelector('.x-review-product');
      if (ratings && /^\(\s*0\s*\)$/.test(ratings.textContent.trim())) ratings.hidden=true;
      const details=element('a','ev-catalog-details',t('details','View details'));
      details.href=title.href;
      details.setAttribute('aria-label',`View details for ${fullTitle}`);
      const arrow=element('span','','→'); arrow.setAttribute('aria-hidden','true'); details.append(arrow);
      price.after(details);
      const link=card.querySelector('.image-first-hover')?.closest('.x-labels-data');
      if (link) imageObserver.observe(link);
    });
  };
  const prepareCollection = () => {
    if (!main.classList.contains('theme-template-collection')) return;
    const banner=main.querySelector('.x-section-collection-banner');
    const title=banner?.querySelector('h1');
    if (!title) return;
    const categoryImage = document.querySelector('template[data-ev-category-image]')?.content.querySelector('img')?.cloneNode(true);
    const hero=element('div','ev-collection-hero');
    const text=element('div','ev-collection-copy');
    const eyebrow=element('p','ev-eyebrow',t('collection_eyebrow','The Evolvé collection'));
    title.className='ev-collection-title';
    text.append(eyebrow,title);
    const media=element('div','ev-collection-image');
    hero.append(text);
    if (categoryImage) {
      media.append(categoryImage);
      hero.append(media);
    } else {
      hero.classList.add('ev-collection-hero--text-only');
    }
    const description=banner.querySelector('.collection-page-description');
    banner.replaceChildren(hero,navigation(categories,'/collections',t('categories','Jewelry categories'),'ev-category-nav'));
    banner.classList.add('ev-collection-banner');
    main.querySelector('[id$="__collection_header_band"]')?.classList.add('ev-replaced-banner');
    main.querySelectorAll('.filter-advanced').forEach(filter => {
      if (filter.querySelectorAll('input[type="checkbox"]').length < 2) filter.classList.add('ev-single-filter');
    });
    if (description) {
      const details=element('details','ev-collection-description');
      details.append(element('summary','',t('collection_about','About this collection')),description);
      banner.append(details);
    }
  };
  const prepareTables = () => main.querySelectorAll('.rte table,.shopify-policy__body table').forEach(table => {
    if (table.parentElement.classList.contains('ev-table-scroll')) return;
    const wrapper=element('div','ev-table-scroll');
    wrapper.tabIndex=0;
    wrapper.setAttribute('role','region');
    wrapper.setAttribute('aria-label',t('table_label','Size and information table'));
    table.before(wrapper); wrapper.append(table);
  });
  const prepareInformation = () => {
    const container=main.querySelector('.page__container');
    const body=container?.querySelector('.page__body');
    const rte=body?.querySelector('.rte');
    const title=container?.querySelector('h1');
    if (!rte || !title) return;
    container.classList.add('ev-information-page');
    title.classList.remove('anm-move-up');
    const first=rte.firstElementChild;
    if (first && /^H[1-6]$/.test(first.tagName) && first.textContent.trim().toLowerCase()===title.textContent.trim().toLowerCase()) first.remove();
    if (path==='/pages/about') {
      container.classList.add('ev-about-page');
      const figure=element('figure','ev-about-portrait');
      figure.append(photo('craft',t('craft_image','Close examination of a gold ring'),''));
      body.append(figure);
      body.classList.add('ev-about-layout');
    } else if (help.some(([,slug]) => path===`/pages/${slug}`)) {
      const layout=element('div','ev-help-layout');
      const aside=element('aside','ev-help-sidebar');
      aside.append(element('p','ev-eyebrow',t('care','Customer care')),navigation(help,'/pages',t('care','Customer care'),'ev-help-nav'));
      body.before(layout); layout.append(aside,body);
    }
    if (path==='/pages/size-guide') {
      rte.querySelectorAll('table').forEach(table => table.querySelector('tr')?.querySelectorAll('td').forEach(cell => {
        const heading = element('th', '', cell.textContent); heading.scope = 'col'; cell.replaceWith(heading);
      }));
    }
    if (path==='/pages/faq') {
      const heading=rte.querySelector('h3');
      if (heading?.textContent.trim()==='Frequently Asked Questions') { title.textContent=heading.textContent; heading.remove(); }
      rte.querySelectorAll(':scope > p').forEach(paragraph => {
        const question=paragraph.querySelector(':scope > strong:first-child');
        if (!question) return;
        const details=element('details','ev-help-question');
        const summary=element('summary','',question.textContent);
        question.remove();
        while (paragraph.firstChild && (paragraph.firstChild.nodeName==='BR' || (paragraph.firstChild.nodeType===3 && !paragraph.firstChild.textContent.trim()))) paragraph.firstChild.remove();
        paragraph.before(details); details.append(summary,paragraph);
      });
    }
  };
  const prepareContact = () => {
    const content=main.querySelector('.contact-page-content');
    const container=main.querySelector('[class^="contact-page-container-"]');
    const left=main.querySelector('[class^="contact-col-left-"]');
    if (!content || !container || !left) return;
    const heading=element('header','ev-contact-heading');
    const first=content.firstElementChild;
    const h1=element('h1','',first?.textContent || t('contact','Contact'));
    first?.remove();
    heading.append(element('p','ev-eyebrow',t('care','Customer care')),h1);
    const intro=content.querySelector('p'); if (intro) heading.append(intro);
    container.prepend(heading);
    content.querySelectorAll('h3').forEach(h => {
      if (h.textContent.trim()==='Email us directly' && h.nextElementSibling?.textContent.trim()===main.querySelector('.contact-info-item a[href^="mailto:"]')?.textContent.trim()) {
        h.nextElementSibling.remove(); h.remove();
      }
    });
    left.append(content);
    content.classList.add('ev-contact-notes');
  };
  const prepareProductHelp = () => {
    main.querySelectorAll('[data-product-help]').forEach(link => {
      const data = link.dataset;
      const variantData = link.closest('.product-info')?.querySelector('.variant-selects-main [data-selected-variant]');
      let variant = {id:data.productVariant,sku:link.closest('[data-product-details]')?.querySelector('[data-product-sku]')?.textContent || ''};
      if (variantData) {
        try { variant = JSON.parse(variantData.textContent); }
        catch { return; }
      }
      const target = new URL(link.href, location.origin);
      target.searchParams.set('ev_product', data.productHandle);
      target.searchParams.set('ev_title', data.productTitle);
      target.searchParams.set('ev_product_id', data.productId);
      target.searchParams.set('ev_variant', variant?.id || '');
      target.searchParams.set('ev_sku', variant?.sku || '');
      if (link.href !== target.href) link.href = target.href;
    });
  };
  const prepareContactProduct = () => {
    const form = main.querySelector('[name="contact[body]"]')?.closest('form');
    const params = new URLSearchParams(location.search);
    const handle = params.get('ev_product') || '';
    const title = (params.get('ev_title') || '').trim().slice(0,250);
    const productId = params.get('ev_product_id') || '';
    if (!form || !/^[a-z0-9][a-z0-9-]{0,254}$/.test(handle) || !title || !/^\d{1,20}$/.test(productId)) return;
    const variantId = params.get('ev_variant') || '';
    const sku = (params.get('ev_sku') || '').trim().slice(0,100);
    const productUrl = new URL(`/products/${handle}`,location.origin);
    if (/^\d{1,20}$/.test(variantId)) productUrl.searchParams.set('variant',variantId);
    const context = element('div','ev-contact-product');
    context.append(element('p','', 'Your question is about'));
    const link = element('a','',title); link.href = productUrl.href;
    context.append(link,element('p','',`Product ID: ${productId}${sku ? ` · SKU: ${sku}` : ''}`));
    form.prepend(context);
    const subject = form.querySelector('[name="contact[Subject]"]');
    if (subject && !subject.value) subject.value = `Question about ${title}`;
    [['Product',title],['Product ID',productId],['Product URL',productUrl.href],['SKU',sku]].forEach(([name,value]) => {
      if (!value) return;
      const field = element('input'); field.type='hidden'; field.name=`contact[${name}]`; field.value=value;
      form.append(field);
    });
  };
  const prepareSearch = () => {
    const page=main.querySelector('.search-page');
    if (!page) return;
    const title=page.querySelector('h1');
    title?.classList.remove('anm-move-up');
    const search=page.querySelector('form[role="search"]');
    if (search) search.classList.add('ev-search-form');
    if (!page.querySelector('#items-grid .card-product')) {
      page.classList.add('ev-search-empty');
      page.querySelector('#ProductGridContainer')?.classList.add('ev-redundant-empty');
      const nav=navigation(categories.slice(1),'/collections',t('browse_categories','Browse jewelry categories'),'ev-empty-links');
      search?.parentElement.after(nav);
    }
  };
  const prepareEmptyCart = () => {
    const cart=main.querySelector('#main-cart-items');
    if (!cart || cart.querySelector('.cart-item')) return;
    const content=[...cart.children].find(e=>e.querySelector('h1'));
    if (!content) return;
    cart.classList.add('ev-empty-cart');
    content.classList.add('ev-empty-cart-copy');
    content.querySelector('h1')?.classList.remove('anm-move-up');
    content.append(navigation(categories.slice(1),'/collections',t('browse_categories','Browse jewelry categories'),'ev-empty-links'));
    const figure=element('figure','ev-empty-cart-image');
    figure.append(photo('gifts',t('gift_image','Jewelry presented in an ivory gift box'),'')); cart.append(figure);
  };
  const prepare404 = () => {
    if (!main.classList.contains('theme-template-404')) return;
    main.classList.add('ev-not-found');
    const heading=main.querySelector('h1');
    heading?.classList.remove('anm-move-up');
    const host=heading?.closest('.shopify-section');
    if (host) host.append(navigation(categories.slice(1),'/collections',t('browse_categories','Browse jewelry categories'),'ev-empty-links'));
  };
  const prepareNavigation = () => {
    const header=document.querySelector('.v2-header-wrapper');
    if (!header) return;
    const drawer=header.querySelector('.v2-mobile-drawer');
    const toggle=header.querySelector('.v2-mobile-toggle');
    const close=header.querySelector('.v2-mobile-close');
    if (drawer && toggle && close) {
      const panel=drawer.querySelector('.v2-mobile-drawer-inner');
      drawer.id='ev-mobile-navigation';
      panel.setAttribute('role','dialog');
      panel.setAttribute('aria-modal','true');
      panel.setAttribute('aria-label',t('navigation','Navigation'));
      toggle.setAttribute('aria-controls',drawer.id);
      const logo=header.querySelector('.v2-header-logo img')?.cloneNode(true);
      if (logo) { logo.className='ev-menu-logo'; panel.querySelector('.v2-logo-text')?.replaceWith(logo); }
      const care=navigation([[t('all_collections','All collections'),'collections'],[t('contact','Contact'),'pages/contact'],[t('faq','FAQ'),'pages/faq']],'',t('explore','Explore Evolvé'),'ev-menu-care');
      panel.append(care);
      let wasOpen=false;
      const sync=() => {
        const open=getComputedStyle(drawer).display!=='none';
        toggle.setAttribute('aria-expanded',String(open));
        root.classList.toggle('ev-menu-open',open);
        if (open && !wasOpen) close.focus({preventScroll:true});
        if (!open && wasOpen) toggle.focus({preventScroll:true});
        wasOpen=open;
      };
      new MutationObserver(sync).observe(drawer,{attributes:true,attributeFilter:['style']});
      sync();
      drawer.addEventListener('keydown',event => {
        if (event.key==='Escape') { event.preventDefault(); close.click(); }
        if (event.key!=='Tab') return;
        const controls=[...panel.querySelectorAll('a,button')].filter(node=>node.getClientRects().length);
        const first=controls[0],last=controls.at(-1);
        if (event.shiftKey && document.activeElement===first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement===last) { event.preventDefault(); first.focus(); }
      });
      panel.querySelectorAll('.v2-mobile-nav-item').forEach((item,index) => {
        const button=item.querySelector('button');
        const submenu=item.querySelector('.v2-mobile-subnav');
        if (!button || !submenu) return;
        submenu.id=`ev-mobile-submenu-${index}`;
        button.setAttribute('aria-controls',submenu.id);
        const state=()=>button.setAttribute('aria-expanded',String(getComputedStyle(submenu).display!=='none'));
        new MutationObserver(state).observe(submenu,{attributes:true,attributeFilter:['style']}); state();
      });
    }
    const panels=[...header.querySelectorAll('.v2-mega-panel')];
    const items=[...header.querySelectorAll('.v2-header-nav .v2-nav-item')];
    panels.forEach((panel,index) => {
      const img=panel.querySelector('.v2-mega-card img');
      const key=['women','men','kids','gifts'][index];
      if (img && assets[key]) { img.src=assets[key]; img.removeAttribute('srcset'); }
      const item=items[index],link=item?.querySelector('a');
      if (!link) return;
      panel.id=`ev-desktop-submenu-${index}`;
      link.setAttribute('aria-controls',panel.id);
      let focusWhenOpen=false;
      const state=()=>{
        const open=getComputedStyle(panel).display!=='none';
        link.setAttribute('aria-expanded',String(open));
        if (open && focusWhenOpen) { focusWhenOpen=false; panel.querySelector('a')?.focus(); }
      };
      new MutationObserver(state).observe(panel,{attributes:true,attributeFilter:['style']}); state();
      link.addEventListener('keydown',event => {
        if (event.key==='Escape') { focusWhenOpen=false; item.dispatchEvent(new MouseEvent('mouseleave')); return; }
        if (event.key!=='ArrowDown') return;
        event.preventDefault(); focusWhenOpen=true; item.dispatchEvent(new MouseEvent('mouseenter'));
        requestAnimationFrame(state);
      });
      panel.addEventListener('keydown',event => {
        if (event.key==='Escape') { item.dispatchEvent(new MouseEvent('mouseleave')); link.focus(); }
      });
      panel.addEventListener('focusout',event => {
        if (!panel.contains(event.relatedTarget)) item.dispatchEvent(new MouseEvent('mouseleave'));
      });
    });
  };
  const prepareCartPresentation = () => {
    const display = window.EvolveProductPresentation;
    if (display) document.querySelectorAll('[data-ev-cart-title]').forEach(title => {
      const original = title.textContent.trim();
      const clean = display.cleanTitle(original, Number(title.dataset.evSizeCount) > 1);
      if (original === clean) return;
      title.textContent = clean;
      title.closest('tr,[role="row"]')?.querySelectorAll('[aria-label]').forEach(control => {
        const label = control.getAttribute('aria-label');
        if (label.includes(original)) control.setAttribute('aria-label', label.replace(original, clean));
      });
    });
    const cart = document.querySelector('#cart-icon');
    const bubble = cart?.querySelector('#cart-icon-bubble');
    if (bubble) {
      const raw = bubble.querySelector('[data-value]')?.dataset.value ?? bubble.textContent.trim();
      const value = /^\d+\+?$/.test(raw) ? raw : '0';
      const label = t('cart_count', 'Shopping bag (__COUNT__)').replace('__COUNT__', value);
      if (cart.getAttribute('aria-label') !== label) cart.setAttribute('aria-label', label);
    }
  };
  const prepareHeaderSearch = () => {
    const popup = document.querySelector('#FormSearch');
    const input = popup?.querySelector('#search-in-modal');
    if (!input) return;
    if (!popup.dataset.evSearchReady) {
      popup.dataset.evSearchReady = 'true';
      const content = popup.querySelector('[data-loading-text]') || popup.firstElementChild;
      const heading = element('h2', 'ev-search-heading', t('directory_eyebrow', 'Find your next piece'));
      content.prepend(heading);
      if (!popup.querySelector('#suggest-search')) {
        const shortcuts = navigation(categories.slice(1), '/collections', t('browse_categories', 'Browse jewelry categories'), 'ev-search-shortcuts');
        shortcuts.querySelectorAll('a').forEach(link => {
          const arrow = element('span', '', getComputedStyle(popup).direction === 'rtl' ? '←' : '→');
          arrow.setAttribute('aria-hidden', 'true');
          link.append(arrow);
        });
        content.append(shortcuts);
        const update = () => { shortcuts.hidden = !!input.value.trim(); };
        input.addEventListener('input', update);
        input.addEventListener('focus', update);
        update();
      }
    }
    const products = popup.querySelector('#predictive-search-results .predictive-search-others');
    if (products && products.parentElement.firstElementChild !== products) {
      products.parentElement.prepend(products);
    }
  };
  let lastActiveFilterList;
  const prepareSelectedFilters = () => {
    const toolbar = main.querySelector('#FacetsWrapperDesktop');
    if (!toolbar) return;
    const source = main.querySelector('.facets .active-filter');
    let selected = toolbar.querySelector('.ev-active-filters');
    if (!source?.querySelector('.active-filter-control')) {
      selected?.remove();
      lastActiveFilterList = null;
      return;
    }
    if (selected && source === lastActiveFilterList) return;
    if (!selected) {
      selected = element('div', 'ev-active-filters');
      toolbar.append(selected);
    }
    // Reuse the native labels, remove URLs, and clear-all action.
    selected.replaceChildren(source.cloneNode(true));
    lastActiveFilterList = source;
  };
  const prepareOverlays = () => {
    const filter=document.querySelector('#ProductFilter > div');
    if (filter && !filter.hasAttribute('role')) {
      filter.setAttribute('role','dialog'); filter.setAttribute('aria-modal','true'); filter.setAttribute('aria-label',t('filter_sort','Filter and sort'));
    }
    const cart=document.querySelector('#update-cart');
    if (!cart || cart.querySelector('#CartDrawer-Form') || cart.querySelector('.ev-mini-empty')) return;
    const heading=cart.querySelector('h3');
    if (!heading) return;
    const body=heading.parentElement;
    body.classList.add('ev-mini-empty');
    const img=photo('gifts',t('gift_image','Jewelry presented in an ivory gift box'),'ev-mini-empty-image');
    heading.after(img);
  };
  const prepareMaterialSwipeHint = () => {
    main.querySelectorAll('[class*="material-section-"] .page-width > .overflow-x-auto').forEach(row => {
      if (row.previousElementSibling?.classList.contains('ev-material-swipe-hint')) return;
      const hint = element('p', 'ev-material-swipe-hint');
      hint.hidden = true;
      hint.append(element('span', '', t('swipe_explore','Swipe to explore')));
      const arrow = element('span', '', getComputedStyle(row).direction === 'rtl' ? '←' : '→');
      arrow.setAttribute('aria-hidden', 'true');
      hint.append(arrow);
      row.before(hint);
      const update = () => { hint.hidden = row.scrollWidth <= row.clientWidth + 2; };
      const observer = new ResizeObserver(update);
      observer.observe(row);
      if (row.firstElementChild) observer.observe(row.firstElementChild);
      update();
    });
  };
  const initialize = () => {
    prepareMaterialSwipeHint();
    // Pagination is nested in product links: allow Splide to switch photos
    // while preventing the surrounding link from opening the product page.
    main.addEventListener('click', event => {
      if (event.target.closest('.paginate-dots-card-product')) event.preventDefault();
    }, {capture:true});
    prepareNavigation(); prepareCollection(); prepareInformation(); prepareContact(); prepareContactProduct(); prepareProductHelp(); prepareTables(); prepareSearch(); prepareEmptyCart(); prepare404(); prepareCards(); prepareCardTitles(); prepareOverlays(); prepareCartPresentation(); prepareHeaderSearch(); prepareSelectedFilters();
    let scheduled=false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled=true;
      requestAnimationFrame(() => { scheduled=false; prepareCards(); prepareCardTitles(); prepareOverlays(); prepareCartPresentation(); prepareHeaderSearch(); prepareSelectedFilters(); prepareProductHelp(); });
    }).observe(document.body,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['data-value']});
  };
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
})();
